import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { UserRound, LayoutGrid, Activity, FileText, MessageSquare, MailOpen } from "lucide-react";

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setStats(data)); }, []);

  const cards = [
    { label: "Doctors", key: "doctors", icon: UserRound, color: "red" },
    { label: "Departments", key: "departments", icon: LayoutGrid, color: "blue" },
    { label: "Services", key: "services", icon: Activity, color: "emerald" },
    { label: "Facilities", key: "facilities", icon: LayoutGrid, color: "amber" },
    { label: "Testimonials", key: "testimonials", icon: MessageSquare, color: "violet" },
    { label: "Blog Posts", key: "blog_posts", icon: FileText, color: "sky" },
    { label: "Newsletter", key: "newsletter", icon: MailOpen, color: "emerald" },
    { label: "Total Messages", key: "messages", icon: MessageSquare, color: "slate" },
    { label: "Unread Messages", key: "unread_messages", icon: MailOpen, color: "rose" },
  ];

  return (
    <div data-testid="admin-overview">
      <h1 className="text-2xl lg:text-3xl font-heading font-semibold text-slate-900">Overview</h1>
      <p className="text-slate-500 mt-1">Snapshot of your hospital website content.</p>
      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {cards.map(({ label, key, icon: Ico, color }) => (
          <div key={key} className="card-medi p-6" data-testid={`stat-${key}`}>
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm text-slate-500">{label}</div>
                <div className="mt-2 text-3xl font-heading font-semibold text-slate-900">
                  {stats ? stats[key] : "—"}
                </div>
              </div>
              <div className={`w-12 h-12 rounded-2xl bg-${color}-50 text-${color}-700 grid place-items-center`}>
                <Ico className="w-5 h-5" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
